import { Box, Button, Group, Stack, Text } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";

interface NoResultsFoundProps {
  searchTerm: string;
  onPopularSearchClick: (searchTerm: string) => void;
}

const popularSearches = [
  "Paracetamol",
  "Amoxicillin",
  "Telmisartan",
  "Atorvastatin",
];

export const NoResultsFound = ({
  searchTerm,
  onPopularSearchClick,
}: NoResultsFoundProps) => {
  return (
    <Box
      style={{
        padding: "24px",
        textAlign: "center",
      }}
    >
      <Stack align="center" spacing="md">
        {/* Search Icon */}
        <Box
          style={{
            width: "60px",
            height: "60px",
            backgroundColor: "#F9FAFB",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconSearch size={30} color="#9CA3AF" />
        </Box>

        {/* No Results Message */}
        <Stack spacing="xs" align="center">
          <Text fw={600} size="md" color="#374151" style={{ fontSize: "16px" }}>
            No results found for "{searchTerm}"
          </Text>

          <Text size="sm" color="#6B7280" style={{ fontSize: "14px" }}>
            Try searching with different keywords or check spelling
          </Text>
        </Stack>

        {/* Popular Searches */}
        <Stack spacing="sm" align="center">
          <Text size="sm" color="#6B7280" style={{ fontSize: "14px" }}>
            Popular searches:
          </Text>

          <Group spacing="xs">
            {popularSearches.map((search) => (
              <Button
                key={search}
                variant="light"
                color="gray"
                size="xs"
                onClick={() => onPopularSearchClick(search)}
                style={{
                  backgroundColor: "#F3F4F6",
                  color: "#374151",
                  border: "none",
                  fontSize: "12px",
                  fontWeight: 500,
                  borderRadius: "16px",
                  padding: "6px 12px",
                }}
              >
                {search}
              </Button>
            ))}
          </Group>
        </Stack>

        {/* Footer Tagline */}
        <Text
          size="xs"
          color="#9CA3AF"
          style={{
            fontSize: "12px",
            marginTop: "16px",
          }}
        >
          healthcare solutions to both businesses and individual consumers
          across India.
        </Text>
      </Stack>
    </Box>
  );
};
